
































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { curApiService, ApiService } from '@/services/ApiService';

import moment from 'moment';
import tippy from 'tippy.js';
import { BaseStation } from '@/types';

@Component({
  components:{

  }
})
export default class BaseStationRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) baseStation!: BaseStation;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
  
    
  async mounted() {
    tippy('[data-tippy-content]');
  }

  formatTs(ts:number|undefined): {time: string, ago: string} {

    return {
      time: ts ? moment(ts).format('L LT') : 'N/A',
      ago: ts ? moment(ts).fromNow() : 'N/A'
    };
  }

  formatName(name:string): string {
    if(name.length <= 30)
      return name;
    return name.substring(0, 27) + '...';
  }
}

